import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  inject,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import {
  RoleAction,
  RolePermissionSubject,
  ShiftTemplate,
} from '@wilson/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ShiftTemplateSelectService } from './shift-template-select.service';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-shift-template-select',
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    TranslateModule,
    AuthorizationModule,
    NzTooltipModule,
  ],
  templateUrl: './shift-template-select.component.html',
  styleUrl: './shift-template-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftTemplateSelectComponent implements OnInit {
  private shiftTemplateSelectService = inject(ShiftTemplateSelectService);

  @Input()
  isShiftTemplateDropDownOpen!: boolean;

  @Input()
  selectedShiftTemplate!: ShiftTemplate | null;

  @Output()
  opened = new EventEmitter<boolean>();

  @Output()
  selectedShiftTemplateChange = new EventEmitter<ShiftTemplate | null>();

  @Output()
  startDrag = new EventEmitter<ShiftTemplate>();

  @Output()
  endDrag = new EventEmitter();

  protected nzDropdownStyle = {
    'min-width': '16rem',
  };

  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  protected selectTemplate(template: ShiftTemplate): void {
    this.selectedShiftTemplateChange.next(template);
  }

  protected shiftTemplates$!: Observable<ShiftTemplate[]>;

  ngOnInit(): void {
    this.shiftTemplates$ =
      this.shiftTemplateSelectService.getAllWithActivityTemplatesCached();
  }
}
